import {
  DataAccessRequestSharingDisplayStatus,
  DataAccessRequestSharingStatus,
  DataAccessRequestStatus
} from 'services/data-access-requests/enums'
import type { DataAccessRequestDetail, DataAccessRequestSharing } from 'services/data-access-requests/types'
import type { StudyId } from 'services/shared/schemas/studyIdSchema'

export const DATA_ACCESS_REQUEST_SHARING_STATUS_LABELS: Record<DataAccessRequestSharingDisplayStatus, string> = {
  [DataAccessRequestSharingDisplayStatus.Processing]: 'Processing',
  [DataAccessRequestSharingDisplayStatus.Shared]: 'Shared',
  [DataAccessRequestSharingDisplayStatus.Failed]: 'Failed',
  [DataAccessRequestSharingDisplayStatus.NotShared]: 'Not shared'
}

const SHARING_STATUS_TO_DISPLAY_STATUS: Record<DataAccessRequestSharingStatus, DataAccessRequestSharingDisplayStatus> =
  {
    [DataAccessRequestSharingStatus.Pending]: DataAccessRequestSharingDisplayStatus.Processing,
    [DataAccessRequestSharingStatus.Shared]: DataAccessRequestSharingDisplayStatus.Shared,
    [DataAccessRequestSharingStatus.Failed]: DataAccessRequestSharingDisplayStatus.Failed
  }

export interface DataAccessRequestSharingMetadataInput {
  status: DataAccessRequestStatus
  studyId?: StudyId
  dataAccessRequestDetail?: DataAccessRequestDetail
  sharing?: DataAccessRequestSharing
}

export interface DataAccessRequestSharingMetadata {
  sharingDisplayStatus: DataAccessRequestSharingDisplayStatus
  sharingStatusLabel: string
  targetWorkspaceName?: string
  failureReason?: string
}

export const getDataAccessRequestSharingMetadata = (
  input: DataAccessRequestSharingMetadataInput
): DataAccessRequestSharingMetadata | undefined => {
  const { status, studyId, dataAccessRequestDetail, sharing } = input

  if (sharing !== undefined) {
    const sharingDisplayStatus = SHARING_STATUS_TO_DISPLAY_STATUS[sharing.status]

    return {
      sharingDisplayStatus,
      sharingStatusLabel: DATA_ACCESS_REQUEST_SHARING_STATUS_LABELS[sharingDisplayStatus],
      targetWorkspaceName: sharing.targetWorkspaceName,
      failureReason: sharing.failureReason
    }
  }

  const canShowUnsharedConnection =
    status === DataAccessRequestStatus.Approved && studyId !== undefined && studyId.length > 0

  if (canShowUnsharedConnection && dataAccessRequestDetail?.isUnshared === true) {
    return {
      sharingDisplayStatus: DataAccessRequestSharingDisplayStatus.NotShared,
      sharingStatusLabel: DATA_ACCESS_REQUEST_SHARING_STATUS_LABELS[DataAccessRequestSharingDisplayStatus.NotShared]
    }
  }

  return undefined
}
